export default __webpack_public_path__ + "static/slide1-mobile-a31749a3f52d0d6102e99f21906cd65c.png";